"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithText = void 0;
var react_1 = __importStar(require("react"));
var paragraphy_component_1 = require("../../token/paragraphy/paragraphy.component");
var styles_1 = require("./styles");
var IconWithText = function (_a) {
    var id = _a.id, className = _a.className, icon = _a.icon, text = _a.text, ariaLabel = _a.ariaLabel, classNameText = _a.classNameText, typeLabel = _a.typeLabel, dataTestId = _a.dataTestId, formatter = _a.formatter;
    var textoFormatado = formatter ? formatter(text) : text;
    var possuiAriaLabel = (0, react_1.useCallback)(function () {
        var _a;
        return (_a = (ariaLabel && ariaLabel !== '')) !== null && _a !== void 0 ? _a : false;
    }, [ariaLabel]);
    var textoEstilizado = (0, react_1.useMemo)(function () {
        return typeLabel ? (react_1.default.createElement(styles_1.IconWithTextLabelStyled, { "aria-hidden": possuiAriaLabel(), className: classNameText, "data-testid": 'texto-label' },
            react_1.default.createElement(paragraphy_component_1.P, null, textoFormatado))) : (react_1.default.createElement(styles_1.IconWithTextParagraphyStyled, { "aria-hidden": possuiAriaLabel(), className: classNameText, "data-testid": 'texto-paragrafo' },
            react_1.default.createElement(paragraphy_component_1.P, null, textoFormatado)));
    }, [classNameText, possuiAriaLabel, textoFormatado, typeLabel]);
    return (react_1.default.createElement(styles_1.IconWithTextSectionStyled, { id: id, className: className, typeLabel: typeLabel, "data-testid": dataTestId },
        react_1.default.createElement(styles_1.OmitIconStyled, { "aria-hidden": true }, icon),
        textoEstilizado,
        possuiAriaLabel() ? (react_1.default.createElement("span", { "data-testid": "span-acessibilidade", className: "somenteLeitorDeTela" }, ariaLabel)) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.IconWithText = IconWithText;
